jQuery.noConflict();
(function($){

//Inview
$(function() {
  $('.InviewFade').on('inview', function(event, isInView) {
    if (isInView) {
    //表示領域に入った時
      $(this).addClass('fadeInUp');
    } else {
    //表示領域から出た時
      //$(this).removeClass('fadeInUp');
      //$(this).css('opacity',0); 非表示にしておく
    }
  });
});

//アコーディオン
$('.FAQ__Button').click(function(){
  $(this).toggleClass('Selected');
  $($(this).parent().attr('data-content')).slideToggle();
});

// ドロップダウンメニュー
$(function() {
w = $(window).width();
if (w <= 600) { //SP
  var $body = $('body');
  //開閉用ボタンをクリックでクラスの切替え
  $('#js__btn').on('click', function () {
    scrollPosition = $(window).scrollTop();
  $body.toggleClass('open').css({'top': -scrollPosition});
  });
  $('.menu-item .sub-menu').hide();
    //クリックされるたびに呼ばれる
  $(".menu-item-has-children a").on("click", function() {
    var windowWidth = window.innerWidth;
    // クリックされた時、windowWidthが600以下だと実行する
    if (windowWidth <= 600) {
      $(this).next("ul").slideToggle();
      $(this).toggleClass("on");
    }
  });
} else { //PC
  $('.menu-item').hover(function() { //PC
    //カーソルが重なった時
    //$(this).children(".sub-menu").slideDown();
    $(this).children(".sub-menu").slideDown(200,function(e){$(this).children(".sub-menu").stop(false, true);});
	$(this).children(".sub-menu").addClass("open");
  }, function() {
    //カーソルが離れた時
    //$(this).children(".sub-menu").slideUp();
	$(this).children(".sub-menu").hide();
	$(this).children(".sub-menu").removeClass("open");
  });
}
$(window).resize(function(){
	checkBreakPoint();
});
});

//サイドフローティング
$(function () {
  var SideFloating = $('.SideFloating');
  SideFloating.hide();
  $(window).scroll(function () {
    if ($(this).scrollTop() > 600) {
      SideFloating.fadeIn();
    } else {
      SideFloating.fadeOut();
    }
  });
  /*pagetop.click(function () {
    $('body, html').animate({
        scrollTop: 0
    }, 500);
    return false;
  }); */
});

//アンカーリンクのズレを調整
$(window).on('load', function() {
  let headerHeight = $('.GlobalLayout__Header').outerHeight();
  let urlHash = location.hash;
  if (urlHash) {
    let position = $(urlHash).offset().top - headerHeight;
    $('html, body').animate({ scrollTop: position }, 0);
  }
});

//得々プラン50：カウントダウンタイマー
$(function() {
  $('.CountDownTimer').yycountdown({
    endDateTime:'2023/10/01 00:00:00',
    unit: {d: '日', h: '時間', m: '分', s: '秒後に終了'},
    complete : function(_this){  //カウントダウン完了時のコールバック
                    _this.find('.yycountdown-box').toggleClass('end');
                  }
  });
});

//得々プラン50：モーダルウィンドウ
if ((navigator.userAgent.indexOf('iPhone') > 0) || navigator.userAgent.indexOf('iPod') > 0 || (navigator.userAgent.indexOf('Android') > 0 && navigator.userAgent.indexOf('Mobile') > 0)) {
$(function(){
$(".inline").colorbox({
    inline:true,
    maxWidth:"90%",
    maxHeight:"90%",
    opacity: 0.7
  });
});
//得々プラン50：SPのグロナビ
$(function () {
  var $body = $('body');
  $('body.page-template-page-lp .NaviSP a[href^="#"]').click(function () {
    $body.removeClass('open');
      var adjust = 50; // 移動先を50px上にずらす
      var speed = 400; // ミリ秒
      var href = $(this).attr("href"); //アンカーの値取得
      var target = $(href == "#" || href == "" ? 'html' : href); // 移動先を取得
      var position = target.offset().top - adjust; // 移動先を調整
      $('body,html').animate({ // スムーススクロール
        scrollTop: position
      }, speed, 'swing');
      return false;
  });
  $('body.page-template-page-tokutoku30 .NaviSP a[href^="#"]').click(function () {
    $body.removeClass('open');
      var adjust = 50; // 移動先を50px上にずらす
      var speed = 400; // ミリ秒
      var href = $(this).attr("href"); //アンカーの値取得
      var target = $(href == "#" || href == "" ? 'html' : href); // 移動先を取得
      var position = target.offset().top - adjust; // 移動先を調整
      $('body,html').animate({ // スムーススクロール
        scrollTop: position
      }, speed, 'swing');
      return false;
  });
});
} else {
$(".inline").colorbox({
    inline:true,
    maxWidth:"800px",
    maxHeight:"90%",
    opacity: 0.7
  });
$('body.page-template-page-lp .GlobalNavi a[href^="#"]').click(function () {
    var adjust = 50; // 移動先を50px上にずらす
    var speed = 400; // ミリ秒
    var href = $(this).attr("href"); //アンカーの値取得
    var target = $(href == "#" || href == "" ? 'html' : href); // 移動先を取得
    var position = target.offset().top - adjust; // 移動先を調整
    $('body,html').animate({ // スムーススクロール
      scrollTop: position
    }, speed, 'swing');
    return false;
});
$('body.page-template-page-tokutoku30 .GlobalNavi a[href^="#"]').click(function () {
    var adjust = 50; // 移動先を50px上にずらす
    var speed = 400; // ミリ秒
    var href = $(this).attr("href"); //アンカーの値取得
    var target = $(href == "#" || href == "" ? 'html' : href); // 移動先を取得
    var position = target.offset().top - adjust; // 移動先を調整
    $('body,html').animate({ // スムーススクロール
      scrollTop: position
    }, speed, 'swing');
    return false;
});
}

}(jQuery));